import React from "react";
import { Box, Fade, useScrollTrigger } from "@material-ui/core";

import { Section } from "../components";
import "../styles/index.scss";
import { en } from "../content";

function Skills({ scrollThreshold, isMobile }) {
  const content = en.skills;

  const scrollTrigger = useScrollTrigger({
    threshold: scrollThreshold,
    disableHysteresis: true,
  });

  const renderSkillSets = () => {
    let skillSets = [];
    let i = 1;
    for (const skills of Object.entries(content)) {
      const category = skills[0];
      const skillSet = skills[1];
      category !== "title" &&
        skillSets.push(
          <Fade key={skillSet.label} in={scrollTrigger} timeout={1500 * i++}>
            <Box
              display="flex"
              flexDirection={isMobile ? "column" : "row"}
              className="skillSet"
              mt={i === 0 ? 0 : 1}
            >
              <Box className="skillTitle">{skillSet.label}:</Box>
              <Box className="skillItems">{skillSet.content.join(", ")}</Box>
            </Box>
          </Fade>
        );
    }
    return skillSets;
  };

  return (
    <Box
      className={`skills ${isMobile ? "skillsMobile" : "skillsDesktop"}`}
      top={0}
      position={isMobile ? "relative" : "sticky"}
    >
      <Section>
        <Box>
          <Box className="banner" mb={4}>
            {content.title}
          </Box>
          {renderSkillSets()}
        </Box>
      </Section>
    </Box>
  );
}

export default Skills;
